import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import { ReactComponent as Arrow } from '../assets/small-arrow.svg';
import style from './block.module.scss';

const Case = () => {
    return (
        <BlockWrapper.Div className={style.block}>
            <span>
                <EditableText smartProp="title" tagName="p" placeholder="..." />
                <Arrow />
            </span>
            <EditableText smartProp="text" tagName="p" placeholder="..." />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Case,
    smartProps: {
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Cas',
    },
});
